import React from 'react';
import { useT, availableLocales } from '../i18n';

const ConfigModal = ({ config, onChange, onClose }) => {
  const t = useT();
  const overlayStyle = {
    position: 'fixed', inset: 0, zIndex: 1000,
    background: 'rgba(0,0,0,0.65)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  };
  const boxStyle = {
    background: '#fff', borderRadius: '12px', padding: '1.5rem 1.75rem',
    width: '480px', maxWidth: '92vw',
    boxShadow: '0 8px 32px rgba(0,0,0,0.55)',
    fontFamily: 'Verdana', color: '#222',
  };
  const rowStyle = {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0.6rem 0', borderBottom: '1px solid #eee',
  };
  const labelStyle = { fontSize: '0.95em' };
  const Toggle = ({ checked, onToggle }) => (
    <div onClick={onToggle} style={{
      width: '42px', height: '24px', borderRadius: '12px', cursor: 'pointer',
      background: checked ? '#00aa55' : '#ccc',
      position: 'relative', transition: 'background 0.2s',
      flexShrink: 0,
    }}>
      <div style={{
        position: 'absolute', top: '3px',
        left: checked ? '21px' : '3px',
        width: '18px', height: '18px', borderRadius: '50%',
        background: '#fff', transition: 'left 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      }} />
    </div>
  );
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={boxStyle} onClick={e => e.stopPropagation()}>
        <h5 style={{ margin: '0 0 1rem', fontFamily: 'Verdana', fontSize: '1.05em', fontWeight: 'bold' }}>
          {t('configTitle')}
        </h5>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ ...labelStyle, fontSize: '0.82em', color: '#888', display: 'block', marginBottom: '4px' }}>{t('eventName')}</label>
          <input
            value={config.eventName}
            onChange={e => onChange('eventName', e.target.value)}
            style={{
              width: '100%', background: 'transparent', border: 'none',
              borderBottom: '1px solid #aaa', outline: 'none',
              fontFamily: 'Verdana', fontSize: '0.9em', color: '#222',
              padding: '2px 0',
            }}
          />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>{t('showTime')}</span>
          <Toggle checked={config.showTime} onToggle={() => onChange('showTime', !config.showTime)} />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>{t('showCodriver')}</span>
          <Toggle checked={config.showCodriver} onToggle={() => onChange('showCodriver', !config.showCodriver)} />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>{t('showTeam')}</span>
          <Toggle checked={config.showTeam} onToggle={() => onChange('showTeam', !config.showTeam)} />
        </div>
        <div style={rowStyle}>
          <span style={labelStyle}>{t('allParticipantsVisible')}</span>
          <Toggle checked={config.showAllParticipants} onToggle={() => onChange('showAllParticipants', !config.showAllParticipants)} />
        </div>
        <div style={{ ...rowStyle, borderBottom: 'none' }}>
          <span style={labelStyle}>{t('language') ?? 'Language'}</span>
          <select
            value={config.locale}
            onChange={e => onChange('locale', e.target.value)}
            style={{
              background: '#f5f5f5', border: '1px solid #ccc', borderRadius: '6px',
              fontFamily: 'Verdana', fontSize: '0.88em', color: '#222',
              padding: '3px 8px', cursor: 'pointer', outline: 'none',
            }}
          >
            {availableLocales.map(l => (
              <option key={l.code} value={l.code}>{l.label}</option>
            ))}
          </select>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.2rem' }}>
          <button onClick={onClose} style={{
            background: 'none', border: '1px solid #bbb', borderRadius: '6px',
            padding: '0.4em 1.1em', cursor: 'pointer', fontFamily: 'Verdana', fontSize: '0.9em',
          }}>{t('close')}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfigModal;
